<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex items-center w-full p-4 pl-6">
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <img class="Cohe" src="assets/images/logo/Cohe.webp" width="120" height="40" alt="">
      </div>
      <!-- Components -->
      <div class="flex items-center ml-auto">
        <notifications></notifications>
        <user [showAvatar]="false"></user>
      </div>
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full p-4">
      <div class="relative ">

        <div class="flex-0  rounded-full overflow-hidden">

          @if (!imageUrl) {
          <img class="profileLogo " src="assets/images/logo/dummy-profile-pic2.jpg" alt="">
          }
          @if (imageUrl) {
          <img class="profileLogo" [src]="imageUrl" alt="">
          }
        </div>

      </div>
      <div class="flex flex-col items-center justify-center w-full mt-6">
        <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
          {{userName}}
        </div>
        @if (showEmpCode) {
        <div
          class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary employeeCode">
          {{employeeCode}} | {{designation}}
        </div>
        }
      </div>
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationContentFooter>
  <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-1">
    <img class="max-w-56 logo" src="assets/images/logo/Coherent.png" alt="">
  </div>

</ng-container>

</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    <div class="col-md-9 d-md-block d-none">
      <label class="flex text-3xl  font-medium text-primary-900 ml-2 ">Coherent Pixels Systems Pvt.
        Ltd...</label>
    </div>
    <div class="col-12 d-md-none d-block">
      <div class="col-10">
        <label class="text-primary-900 ">Coherent Pixels Systems Pvt.
          Ltd...</label>
      </div>


    </div>
    <!-- Components -->

  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    @if (true) {
    <router-outlet></router-outlet>
    }
  </div>



</div>